// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'
import 'firebase/firestore'
//import firebaseConfig from './firebaseConfig'

// Initialize Firebase
const firebaseConfig = {
    apiKey: 'AIzaSyC1g8vLQNMtybOjXFP3wNy8MuXBDRoHfec',
    authDomain: 'chefsteinonline.firebaseapp.com',
    databaseURL: 'https://chefsteinonline.firebaseio.com',
    projectId: 'chefsteinonline',
    storageBucket: 'chefsteinonline.appspot.com',
    messagingSenderId: '780210823888',
    appId: '1:780210823888:web:f4b08848277e45b9f374d5'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore();


//firebase.initializeApp(config)
